import { useState } from "react";
import Gallery from "../gallery/Gallery";
import "./contactinfo.css";
import SocialIcons from "../socialIcons/SocialIcons";
import InstagramEmbed from "../instagram/InstagramEmbed.jsx";

const ContactInfo = ({ blogInfo }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const res = await fetch("http://localhost:5000/contact-backend/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Failed to send message. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setStatus("An error occurred. Please try again.");
    }
  };

  return (
    <div className="contactPage">
      <div
        className="d-flex align-items-center justify-content-start bg-cover bg-center text-white position-relative w-100 intro-img"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_UPLOAD_URL}${
            blogInfo.contact_photo?.formats?.large?.url ||
            blogInfo.contact_photo?.url
          })`,
          height: "30vh", // or whatever height you want
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="d-flex flex-column z-3 position-relative ps-5">
          <h1>{blogInfo.contact_title}</h1>
        </div>
      </div>

      {/* <img
        className="contactImage"
        src={`${process.env.REACT_APP_UPLOAD_URL}${
          blogInfo.contact_photo?.formats?.large?.url ||
          blogInfo.contact_photo?.url
        }`}
        alt="Contact"
      /> */}

      <div className="contact-section">
        {/* <h1>{blogInfo.contact_title}</h1> */}
        <p>{blogInfo.contact_desc}</p>

        <div className="contactFormWrapper d-none">
          <h2 className="no-text-shadow">Send Us a Message</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit">Send Message</button>
            {status && <p className="form-status">{status}</p>}
          </form>
        </div>
      </div>

      {/* <Gallery title="Connect on Social" description="info about" /> */}

      {/* <InstagramEmbed postUrl="https://www.instagram.com/p/DK8Lrr7MTHT/?img_index=1" /> */}

      {blogInfo?.links && <SocialIcons links={blogInfo?.links} type="large" />}
    </div>
  );
};

export default ContactInfo;
